<template>
  <div style="position: absolute; right: 15px; top: 10px; cursor: pointer" @click="close">
    <img src="https://oss2.1dq.com/app/img/close.png" width="25" height="25">
  </div>
</template>

<script>
export default {
  name: "modelClose",
  methods : {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>